export default "__VITE_ASSET__c712a707__"